import { Alert, Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import { useState } from "react";
import { authService } from "services/authService";
import { DOCUSTREAM_BANNER_DISMISSED_KEY } from "@/constants";

const getInitialState = () => {
  const referrer = document.referrer;
  const urlParams = new URLSearchParams(window.location.search);
  const isFromDocustream =
    referrer.includes("app.docustream.ai") ||
    urlParams.get("from") === "docustream";
  const wasDismissed = localStorage.getItem(DOCUSTREAM_BANNER_DISMISSED_KEY);

  if (isFromDocustream && !wasDismissed) {
    const token = authService.getToken();
    return {
      visible: true,
      isSocialLogin: token?.provider === "google",
    };
  }

  return { visible: false, isSocialLogin: false };
};

export const DocustreamMergeBanner = () => {
  const t = useTranslate();
  const [{ visible, isSocialLogin }, setState] = useState(getInitialState);

  const handleClose = () => {
    localStorage.setItem(DOCUSTREAM_BANNER_DISMISSED_KEY, "true");
    setState((prev) => ({ ...prev, visible: false }));
  };

  if (!visible) {
    return null;
  }

  return (
    <Alert
      message={t("pages.login.docustreamMerge.title")}
      description={
        <>
          <Typography.Paragraph style={{ margin: 0 }}>
            {t("pages.login.docustreamMerge.description")}
          </Typography.Paragraph>
          {isSocialLogin && (
            <Typography.Paragraph
              style={{ margin: "8px 0 0 0", fontWeight: 500 }}
            >
              {t("pages.login.docustreamMerge.socialLoginNote")}
            </Typography.Paragraph>
          )}
          <Typography.Text
            type="secondary"
            style={{ display: "block", marginTop: 8 }}
          >
            {t("pages.login.docustreamMerge.signature")}
          </Typography.Text>
        </>
      }
      type="info"
      closable
      onClose={handleClose}
      style={{ marginBottom: 24, width: "60%" }}
    />
  );
};
